<template>
  <div>
    <div class="p-4 font-medium text-xs text-left leading-snug bg-charcoal-100 dark:bg-dark-950">
      <div class="bg-white p-4 rounded-xl text-light-950 dark:bg-dark-800 dark:text-dark-50 shadow">
        <p class="text-lg font-bold mb-0.5">{{ $t('components.Event.guests.title') }}</p>
        <p class="text-sm">{{ $t('components.Event.guests.content', { max: event.maxGuests ?? 5 }) }}</p>

        <InputCount v-model="guests" class="mt-4" :max="event.maxGuests ?? 5" />
      </div>
    </div>

    <div class="bg-white border-t border-charcoal-200 dark:bg-dark-800 dark:border-dark-600 flex items-center space-x-2 p-2.5">
      <ButtonBase style-type="round" class="shrink-0 " color="white" @click="() => emit('previous')">
        <IconBase name="cute/angle-right" class="rotate-180" :width="20" />
      </ButtonBase>

      <ButtonBase
        color="base"
        is-full
        :is-loading="isLoading"
        @click="onNext"
      >
        {{ $t('actions.next') }}
      </ButtonBase>
    </div>
  </div>
</template>

<script lang="ts" setup>
import UserStore from '@/store/user'
import { Event } from '@/classes'

const props = withDefaults(defineProps<{
  event: Event
  onEnd: () => Promise<boolean>
}>(), {

})

const { event } = toRefs(props)

const userStore = UserStore()
const { currentUser } = storeToRefs(userStore)

const guests = defineModel({
  default: 0
})

const emit = defineEmits<{
  (e: 'update', params: { guests: number }): void
  (e: 'next'): void
  (e: 'previous'): void
}>()

const isLoading = ref(false)

const onNext = async () => {
  isLoading.value = true

  emit('update', { guests: guests.value })

  const result = await props.onEnd()
  if (result) emit('next')

  isLoading.value = false
}
</script>